/**
 * Qué es una regla de aprobación GENERAL (sin línea de negocio) y a qué aplica. Pedido de Sebastián (17-oct): que
 * no se confunda con las reglas por línea de negocio. Genérico para cualquier empresa: se deriva de que la regla no
 * tenga línea de negocio.
 *
 * El criterio es el de `evaluateRules` (backend `services/approval-evaluation.service.ts`):
 *  - con «Si aplican varias reglas, que firmen todas» ENCENDIDO, de las reglas que aplicaron queda una por línea de
 *    negocio y la general sólo cuenta si no aplicó ninguna de línea de negocio (`unaPorLob`);
 *  - APAGADO, la general compite con las demás: firma la regla que pide más firmas.
 * Las reglas de presupuesto son otro eje (se suman a cualquiera): no son «generales» en este sentido.
 */

/** ¿Es una regla general? Sin línea de negocio y que no es de presupuesto. */
export function esReglaGeneral(r: {
  lobId?: string | null;
  condicionPresupuesto?: boolean | null;
}): boolean {
  return !r.lobId && r.condicionPresupuesto !== true;
}

/** El texto de ayuda de una regla general, según el modo de la empresa. */
export function textoDeReglaGeneral(firmanTodas: boolean): string {
  return firmanTodas
    ? 'Regla general: se aplica sólo cuando no aplica ninguna regla de línea de negocio (por ejemplo, cotizaciones con ítems sin línea de negocio). Mide la cotización completa.'
    : 'Regla general: no depende de la línea de negocio y mide la cotización completa. Si también aplica una regla de línea de negocio, firma la que pide más firmas.';
}

/** Por qué aplica la general cuando es la que se activa (sólo con «que firmen todas», donde excluye a las de LOB). */
export const MOTIVO_DE_LA_REGLA_GENERAL =
  'Aplica porque ninguna regla de línea de negocio pidió firma (por ejemplo, hay ítems sin línea de negocio).';
